import { Stack, Button, Typography, TextField, Box, LinearProgress } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import useFetch from "../Service/Hooks/useFetch";
import { ApiUrls } from "../Components/Utils/globalVariables";
import { useForm } from "react-hook-form";
import CustomTextField from "../Components/View/Input/TextField";
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

export default function AdminPage() {

    const [fileError, setFileError] = useState(false)
    const [file, setFile] = useState()
    const [submitError, setSubmitError] = useState(false)
    const [loading, setLoading] = useState(false)

    const [{response, isLoading, error}, doPostData] = useFetch(ApiUrls.Excel, "post", true, true)
    const navigate = useNavigate()

    const { handleSubmit, control, reset } = useForm()


    const submitData = (data) => {
        const bodyObj = {
            userName: data.Username,
            password: data.Password
        }
        const formData = new FormData()
        if(file) {
            setFileError(false)
            formData.append("file", file)
        } else {
            setFileError(true)
        }

        if(file) {
            setLoading(true)
            setSubmitError(false)
            doPostData(bodyObj, handleSubmitData, formData)
        }
    }

    const handleSubmitData = (res) => {
        setLoading(false)
        if(res != undefined) {
            toast.success("فایل با موفقیت آپلود شد")
        }
    }

    return (
        <Stack spacing={6} sx={{pt: 10}} alignItems="center" justifyContent="center">
            <Box sx={{maxWidth: {xs: "100%", lg: "600px", height: "60vh"}}}>
                <Stack component="form" onSubmit={handleSubmit(submitData)}>
                    <Typography variant="body1" color="initial" sx={{mt: 3, mb: 1, fontSize: "14px"}}>نام کاربری</Typography>
                    <CustomTextField
                        control={control}
                        name="Username"
                        placeholder="نام کاربری"
                        fullWidth
                        sx={{width: {xs: "100%", lg: "400px"}}}
                        size="small"
                        isRequired={true}
                    />
                    <Typography variant="body1" color="initial" sx={{mt: 3, mb: 1, fontSize: "14px"}}>کلمه عبور</Typography>
                    <CustomTextField
                        control={control}
                        name="Password"
                        placeholder="کلمه عبور"
                        fullWidth
                        sx={{width: {xs: "100%", lg: "400px"}}}
                        size="small"
                        type="password"
                        isRequired={true}
                    />
                    <Typography variant="body1" color="initial" sx={{mt: 3, mb: 1, fontSize: "14px"}}>آپلود فایل</Typography>
                    <TextField
                        id="file"
                        placeholder="آپلود فایل"
                        onChange={(e) => {setFile(e.target.files[0]); setFileError(false)}}
                        fullWidth
                        sx={{width: {xs: "100%", lg: "400px"}}}
                        size="small"
                        type="file"
                        error={fileError}
                        helperText={fileError ? "لطفا فایل را انتخاب کنید" : ""}
                    />
                    <Stack sx={{mt: "60px !important"}} spacing={2} >
                        {
                            loading &&
                            <Stack spacing={2}>
                                <Typography sx={{fontSize: "12px", textAlign: "center"}} color="primary">در حال بارگزاری فایل...</Typography>
                                <LinearProgress />
                            </Stack>
                        }
                        {submitError && <Typography variant="body1" color="error" sx={{mt: 3, mb: 1, fontSize: "14px"}}>نام کاربری یا کلمه عبور اشتباه است</Typography>}
                        <Button disabled={loading} variant="contained" color="primary" type="submit" >
                            ثبت
                        </Button>
                        <Button variant="outlined" color="primary" type="submit" onClick={() => {navigate("/")}} >
                            برگشت
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </Stack>
    )
}